// extracted by mini-css-extract-plugin
export default {"container":"CardService_container__H9tKj","header":"CardService_header__Bsoba","image":"CardService_image__eanD1","description":"CardService_description__ioFq9"};